var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33 21.39h4.35c1.207 0 2.496-.24 3.623-.804 1.048-.563 2.014-1.207 2.82-2.172a10.92 10.92 0 0 0 1.772-3.138c.402-1.127.644-2.333.644-3.62-.001-1.208-.243-2.334-.726-3.541-.403-1.046-1.047-2.172-1.852-3.058-.806-.885-1.772-1.69-2.82-2.172C16.015 2.322 14.807 2 13.518 2H2v27.84h7.33v-8.45zM9.41 8.76h3.625c.564.08 1.047.24 1.369.642.403.403.725 1.207.725 2.334-.001 1.207-.243 1.85-.646 2.252-.322.403-.725.644-1.208.644H9.41V8.76zm3.222 15.93h17.236V30H12.632v-5.31z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPre);
export default __webpack_public_path__ + "static/media/PRE.7917e015bf3da33870002600f43afbf6.svg";
export { ForwardRef as ReactComponent };